export const Loading = () => {
  return (
    <div className="loader-app d-flex align-items-center justify-content-center vh-100">
		<span className="loading"></span>
	</div>
  );
}

export default Loading;
